module.exports = __webpack_public_path__ + "static/media/A7.a5327834.png";